import { combineReducers } from 'redux'
import { navState } from './navReducer'
import entitiesReducer from './entities'
import authReducer from './authReducer'

const rootReducer = combineReducers({ 
  nav: navState,
  entities:entitiesReducer,
  auth:authReducer
})

export default rootReducer
